import { render, staticRenderFns } from "./trxcustomer.vue?vue&type=template&id=ca379654&scoped=true"
import script from "./trxcustomer.vue?vue&type=script&lang=js"
export * from "./trxcustomer.vue?vue&type=script&lang=js"
import style0 from "./trxcustomer.vue?vue&type=style&index=0&id=ca379654&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca379654",
  null
  
)

export default component.exports